import React, { Component } from 'react';
import { connect } from 'react-redux';
import RangeSetterWrapper from '../components/RangeSetterWrapper/RangeSetterWrapper';
import RangeSetterContainer from './RangeSetterContainer';

import { getDeviceTypeComponents, getInitialTriggerSettingsForThermostats, initializeTriggerEntities } from '../../../lib/functions';
import { ThermostatsActions } from '../../../store/actionCreators';
import { setSettingTriggers } from '../../../lib/functions';
import Store from '../../../store';

class SettingControllerContainer extends Component {
  changedTriggerEntities;

  componentDidMount() {
    window.saveSettings = () => {
      const thermostatsState = Store.getState() && Store.getState().thermostats;

      if (thermostatsState != null && thermostatsState.awairQueryParams != null) {
        const initialTriggers = thermostatsState.initialTriggerEntities;
        const changedTriggers = thermostatsState.changedTriggerEntities;
        const targetId = thermostatsState.targetId;
        const deviceUuid = thermostatsState.awairQueryParams.deviceUuid;
        const deviceType = thermostatsState.awairQueryParams.deviceType;
        const action = thermostatsState.action;
        if (initialTriggers != null && changedTriggers != null) {
          let triggerSettingsList = [];
          Object.keys(changedTriggers).forEach(key => {
            if (changedTriggers[key].isEnabled) {
              // Add || Update
              triggerSettingsList.push({
                sensorType: key.toUpperCase(),
                threshold: changedTriggers[key].onAt,
                thresholdType: 'EQUAL_OR_ABOVE',
                duration: 3
              });
            }
          });
          ThermostatsActions.setLoading();

          setSettingTriggers(deviceUuid, deviceType, action, targetId, triggerSettingsList);
        }
      }
    };
  }

  shouldComponentUpdate(nextProps) {
    if (this.props.isValueInitialized === true && nextProps.isValueInitialized === false) {
      return false;
    }
    return true;
  }

  toggleSwitch = (component, isEnabled) => {
    if (component === 'voc_v1') {
      component = 'voc';
    }
    this.changedTriggerEntities = {
      ...this.changedTriggerEntities,
      [component]: {
        ...this.changedTriggerEntities[component],
        isEnabled
      }
    };
    ThermostatsActions.setChangedTriggerEntities(this.changedTriggerEntities);
  };

  onRangeMouseUp = (event, component, rangeValue) => {
    const min = event.target.min;
    const max = event.target.max;
    const value = event.target.value;
    event.target.parentNode.firstChild.style.backgroundSize = `${((value - min) * 100) / (max - min)}% 100%`;

    this.changedTriggerEntities = {
      ...this.changedTriggerEntities,
      [component]: {
        ...this.changedTriggerEntities[component],
        onAt: parseInt(rangeValue, 10)
      }
    };
    ThermostatsActions.setChangedTriggerEntities(this.changedTriggerEntities);
  };

  render() {
    const { triggerSettings, deviceType, isValueInitialized } = this.props;
    let isV1 = false;
    const sensorComponents = getDeviceTypeComponents(deviceType);
    const forInitialSensorComponents = sensorComponents.map(sensor => {
      if (sensor === 'voc_v1') {
        isV1 = true;
        return 'voc';
      }
      return sensor;
    });
    let initialTriggerEntities = getInitialTriggerSettingsForThermostats(triggerSettings, forInitialSensorComponents, isV1);
    if (isValueInitialized) {
      initialTriggerEntities = initializeTriggerEntities(initialTriggerEntities, deviceType);
    }
    this.changedTriggerEntities = { ...initialTriggerEntities };
    ThermostatsActions.setAction(triggerSettings.groupId.action);
    ThermostatsActions.setInitialTriggerEntities(initialTriggerEntities);
    ThermostatsActions.setChangedTriggerEntities(this.changedTriggerEntities);

    const rangeSetterElements = sensorComponents.map((sensorComponent, index) => (
      <RangeSetterContainer
        forInitialAirType={sensorComponent}
        airType={forInitialSensorComponents[index]}
        isEnabled={initialTriggerEntities[forInitialSensorComponents[index]].isEnabled}
        onAt={initialTriggerEntities[forInitialSensorComponents[index]].onAt}
        onChangeIndex={this.changeIndex}
        onToggleSwitch={this.toggleSwitch}
        onRangeMouseUp={this.onRangeMouseUp}
        key={sensorComponent}
      />
    ));

    return <RangeSetterWrapper>{rangeSetterElements}</RangeSetterWrapper>;
  }
}

export default connect(
  ({ thermostats }) => ({
    isValueInitialized: thermostats.isValueInitialized,
    action: thermostats.action
  }),
  () => ({})
)(SettingControllerContainer);



// WEBPACK FOOTER //
// ./src/app/thermostats/containers/SettingControllerContainer.js